import { UserSettingsForm, type UserData } from './UserSettingsForm'

export interface UserSettingsPageProps {
  user: UserData
  loading?: boolean

  // Form configuration
  showRoleSelector?: boolean
  allowedRoles?: string[]
  showPermissionsButton?: boolean
  showPasswordReset?: boolean
  showMfaReset?: boolean
  showStatusToggles?: boolean
  showEmailNotifications?: boolean

  // Callbacks
  onSave?: (formData: UserData) => Promise<void>
  onResetPassword?: (userId: string) => Promise<void>
  onResetMfa?: (userId: string) => Promise<void>
  onViewPermissions?: () => void

  // Loading states
  saveLoading?: boolean
  passwordResetLoading?: boolean
  mfaResetLoading?: boolean
}

export function UserSettingsPage({
  user,
  loading = false,
  showRoleSelector = true,
  allowedRoles,
  showPermissionsButton = true,
  showPasswordReset = true,
  showMfaReset = true,
  showStatusToggles = true,
  showEmailNotifications = true,
  onSave,
  onResetPassword,
  onResetMfa,
  onViewPermissions,
  saveLoading = false,
  passwordResetLoading = false,
  mfaResetLoading = false,
}: UserSettingsPageProps) {
  return (
    <UserSettingsForm
      user={user}
      loading={loading}
      showRoleSelector={showRoleSelector}
      allowedRoles={allowedRoles}
      showPermissionsButton={showPermissionsButton}
      showPasswordReset={showPasswordReset}
      showMfaReset={showMfaReset}
      showStatusToggles={showStatusToggles}
      showEmailNotifications={showEmailNotifications}
      onSave={onSave}
      onResetPassword={onResetPassword}
      onResetMfa={onResetMfa}
      onViewPermissions={onViewPermissions}
      saveLoading={saveLoading}
      passwordResetLoading={passwordResetLoading}
      mfaResetLoading={mfaResetLoading}
    />
  )
}
